module.exports = __webpack_public_path__ + "img/O_Mapa-B.ee09d705.svg";